import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { useQuery } from 'react-query';
import { LinearGauge } from '../LinearGauge';
import { Arrow, ArrowColor, ArrowDirection } from '../Arrow';
import { GradeDisplay } from '../GradeDisplay';
import * as API from '../../API';
import './EssentialKeyfigures.scss';
export var EssentialKeyfiguresFilter;
(function (EssentialKeyfiguresFilter) {
    EssentialKeyfiguresFilter["StrongestKeyfigures"] = "strongest";
    EssentialKeyfiguresFilter["WeakestKeyfigures"] = "weakest";
    EssentialKeyfiguresFilter["RocketKeyFigures"] = "rocket";
})(EssentialKeyfiguresFilter || (EssentialKeyfiguresFilter = {}));
;
export const EssentialKeyfigures = ({ className, knr, sector, filter }) => {
    var _a, _b;
    const { data: sectorResultsData } = useQuery(`kb/kommuner/sektorresultater/${knr}/${sector}`, () => API.fetchMunicipalitySectorResults(knr, sector));
    const resultRef = useRef(null);
    const keyfiguresRef = useRef(null);
    const arrowColorRef = useRef(ArrowColor.amber);
    const arrowDirectionRef = useRef(ArrowDirection.diagonal);
    if (sectorResultsData) {
        resultRef.current = (_a = sectorResultsData[sector]) !== null && _a !== void 0 ? _a : null;
        switch (filter) {
            case EssentialKeyfiguresFilter.StrongestKeyfigures:
                keyfiguresRef.current = resultRef.current.nokkeltall.sterkeste;
                arrowColorRef.current = ArrowColor.green;
                arrowDirectionRef.current = ArrowDirection.up;
                break;
            case EssentialKeyfiguresFilter.WeakestKeyfigures:
                keyfiguresRef.current = resultRef.current.nokkeltall.svakeste;
                arrowColorRef.current = ArrowColor.red;
                arrowDirectionRef.current = ArrowDirection.down;
                break;
            case EssentialKeyfiguresFilter.RocketKeyFigures:
                keyfiguresRef.current = resultRef.current.nokkeltall.klatrere;
                arrowColorRef.current = ArrowColor.amber;
                arrowDirectionRef.current = ArrowDirection.diagonal;
                break;
            default:
                keyfiguresRef.current = null;
                arrowColorRef.current = ArrowColor.amber;
                arrowDirectionRef.current = ArrowDirection.diagonal;
        }
    }
    const clsx = [
        'essential-keyfigures',
        filter,
        className
    ].join(' ');
    const intro = {
        strongest: "Best",
        weakest: "Dårligst",
        rocket: "Klatreren"
    };
    const jsxKeyfigures = ((_b = keyfiguresRef.current) !== null && _b !== void 0 ? _b : []).map((kf, index) => {
        const jsxTimelines = kf.tidsserie.map((v) => {
            return (_jsx(LinearGauge, { compact: true, label: v.aar, value: v.rangering, max: 357, inverted: true, ranking: true }, `${v.aar}`));
        });
        return (_jsxs("div", { className: "keyfigure", children: [_jsxs("h3", { children: [kf.etikett, ": #", kf.tidsserie[0].rangering] }), _jsx("h4", { children: kf.beskrivelse }), _jsxs("dl", { className: "grade", children: [_jsx("dt", { children: _jsx(GradeDisplay, { value: kf.tidsserie[0].karakter }) }), _jsxs("dd", { children: ["Karakter (", kf.tidsserie[0].karakter, ")"] })] }), _jsx("div", { className: "gauges", children: jsxTimelines })] }, `${index}`));
    });
    return (_jsxs("div", { className: clsx, children: [_jsxs("div", { className: "arrow-kicker", children: [_jsxs("h2", { className: `title`, children: [intro[filter], ":"] }), _jsx(Arrow, { color: arrowColorRef.current, direction: arrowDirectionRef.current })] }), jsxKeyfigures] }));
};
